import { DeliveryAddressContextProvider, useOrderDeliveryAddress } from '../application/useOrderDeliveryAddress';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { OrderConfirmationUI } from './OrderConfirmationUI';
import { CartView, useCartContext } from '../../cart';
import React, { useEffect, useRef, useState } from 'react';
import { ContainerTitle, TitleSeccion } from '../../components/Theme/theme.elements';
import { ContainerMenu, RoutePathBreadcrumb } from '../../ui';
import { TextAreaUI } from '../../ui/components/TextAreaUI';
import { OrderRecap } from './OrderRecap';
import { DeliveryAddress } from './DeliveryAddress';
import { placeOrderBis } from '../infrastructure/OrderApi';
import { initial, isFailure, isInitial, isPending, isSuccess } from '../../common/domain/RemoteData.model';
import { PreCheckoutFlow } from "../application/PreCheckoutFlow";
import { remoteDataWithSetter } from "../../common/utils/remoteDataWithSetter";
import { GtmService } from "../../infrastructure/analytics/GtmService";
import { useComercialContext } from "../../comercial/ComercialContext";

export const Checkout = () => {
  return (
    <DeliveryAddressContextProvider>
      <CheckoutContent />
    </DeliveryAddressContextProvider>
  );
};

// TODO: would this component location be better at the cart domain?
const CheckoutContent = () => {
  const { cart, loadCart } = useCartContext();
  const { clearActingAsCliente } = useComercialContext();
  const { defaultDeliveryAddressRemoteData, selectedAddressId } = useOrderDeliveryAddress();
  const [placeOrderDisabled, setPlaceOrderDisabled] = useState(false);
  const [comment, setComment] = useState('');
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [orderRemoteData, setOrderRemoteData] = useState(initial(null))

  // Store cart products to send them to GA4 even if cart is cleared after purchase
  const cartProductsRef = useRef([]);

  useEffect(() => {
    if (cart?.products) {
      cartProductsRef.current = cart.products;
    }
    setPlaceOrderDisabled(cart?.products?.length <= 0 || cart?.deprecatedProducts?.length > 0 || !isSuccess(defaultDeliveryAddressRemoteData));
  }, [cart, defaultDeliveryAddressRemoteData]);

  const navigate = useNavigate();

  const _placeOrder = async () => {
    toast.info('Realizando pedido.');
    setPlaceOrderDisabled(true);
    setShowConfirmationModal(false);
    await remoteDataWithSetter(setOrderRemoteData, () => placeOrderBis(comment, selectedAddressId));
  };

  useEffect(() => {
    if (isInitial(orderRemoteData) || isPending(orderRemoteData)) {
      return;
    }

    if (isSuccess(orderRemoteData)) {
      clearActingAsCliente();
      // GA4 Purchase Event
      const order = orderRemoteData.value;
      // We use the cart state captured before (via ref) or current if available, ensuring we have items
      // Note: order.precioTotal includes everything, we might need to parse it if it's string '12.00 €' but usually it's number or we assume structure matches.
      // However based on Order.model.js, precioTotal is string. GtmService expects number.
      // Since we don't have exact number, let's try to use cart.subtotal if available or parse.
      // For safety and consistency with previous events, we rely on the cart data we have.
      // But actually, we should use the confirmed values.
      // Given the Order model is strings with potential currency symbols, we might rely on the cart's numeric values which are what the user agreed to pay.

      // Simple parsing for safety if needed, assuming cart structure has numeric subtotal/tax
      GtmService.logPurchase(
        order.code,
        cart?.subtotal || 0, // Fallback to cart subtotal
        cart?.tax || 0,      // Fallback to cart tax
        cartProductsRef.current
      );

      navigate('/');
      toast.success(OrderConfirmationUI(orderRemoteData.value));
    } else if (isFailure(orderRemoteData)) {
      toast.error('Error al realizar el pedido. Contacte con nosotros.');
    }
    loadCart();
  }, [loadCart, navigate, orderRemoteData]);

  const handlePlaceOrder = () => {
    setShowConfirmationModal(true);
  };

  return (
    <>
      <div className="container">
        <div className="my-4">
          <TitleSeccion>Resumen de tu pedido</TitleSeccion>
          <RoutePathBreadcrumb />
        </div>

        <div className="row gap-4 gap-md-0">
          <div className="col-12 col-md-9">
            <CartView />
          </div>
          <div className="col-12 col-md-3">
            <div className="d-flex flex-column">
              <DeliveryAddress />
              <div>
                <ContainerMenu>
                  <ContainerTitle>
                    Observaciones
                  </ContainerTitle>
                  <TextAreaUI
                    data={{
                      value: comment,
                      max: 1000,
                      placeholder: 'Añada comentario sobre su pedido'
                    }}
                    actions={{ handleChange: setComment }}
                  />
                </ContainerMenu>
              </div>
              <OrderRecap />
              <div className="text-center">
                <button type="button"
                  className="btn btn-primary"
                  disabled={placeOrderDisabled}
                  onClick={handlePlaceOrder}>
                  Realizar Pedido
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {
        showConfirmationModal &&
        <PreCheckoutFlow
          show={showConfirmationModal}
          onConfirm={() => _placeOrder()}
          onCancel={() => {
            setShowConfirmationModal(false)
            loadCart();
          }}
        />
      }
    </>
  );
}
  ;